/* Mesmerize · Trust numbers · mes-trust-numbers.js (no dependencies)
   Count-up once per stat when it is half visible: duration from the section (default 1.1s), ease-out cubic.
   The HTML already holds the final number. Near the viewport (200px) the visible span is set to its zero state,
   then it counts up when half visible. Reduced motion or no IntersectionObserver: nothing changes. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(v, dec, comma) {
    var s = v.toFixed(dec);
    if (comma) { var p = s.split('.'); p[0] = Number(p[0]).toLocaleString('en-IN'); s = p.join('.'); }
    return s;
  }
  function text(el, v) {
    var d = el.dataset;
    el.textContent = (d.pre || '') + fmt(v, +d.dec || 0, d.comma === '1') + (d.suf || '');
  }

  function init(root) {
    if (root.__mtn || reduce || !window.IntersectionObserver) return;
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
    if (!els.length) return;
    var dur = +root.getAttribute('data-dur') || 1100;
    var state = { near: null, half: null, els: els };
    root.__mtn = state;

    function run(el) {
      var t = +el.dataset.count || 0, st = null;
      function step(ts) {
        if (st === null) st = ts;
        var p = Math.min((ts - st) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        text(el, t * e);
        if (p < 1) el.__mtnRaf = requestAnimationFrame(step); else el.__mtnRaf = 0;
      }
      el.__mtnRaf = requestAnimationFrame(step);
    }

    state.half = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        state.half.unobserve(e.target);
        run(e.target);
      });
    }, { threshold: 0.5 });

    state.near = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      state.near.disconnect();
      els.forEach(function (el) { text(el, 0); state.half.observe(el); });
    }, { rootMargin: '200px 0px' });
    state.near.observe(root);
  }

  function destroy(root) {
    var s = root && root.__mtn;
    if (!s) return;
    if (s.near) s.near.disconnect();
    if (s.half) s.half.disconnect();
    s.els.forEach(function (el) { if (el.__mtnRaf) cancelAnimationFrame(el.__mtnRaf); });
    root.__mtn = null;
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('.mtn'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.mtn'), destroy);
  });
})();
